import React from 'react';

export function NapModal({ napModal, setNapModal, exchanges, variableByQuestionId }) {
    if (!napModal) return null;

    const nap = napModal.nap || {};
    const extracted = (nap && nap.extractedData && typeof nap.extractedData === 'object') ? nap.extractedData : {};
    const analysis = (nap && nap.analysis) || {};
    const next = (nap && nap.nextInstruction) || {};
    const adv = nap && nap.shouldAdvanceSurvey;

    let expectedVar = '';
    try {
        const seq = napModal.exchange_seq;
        const row = (exchanges || []).find(r => r && r.exchange_seq === seq);
        const qid = row && row.question_id;
        expectedVar = (qid && variableByQuestionId && variableByQuestionId[String(qid)]) || '';
    } catch (_) { expectedVar = ''; }

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setNapModal(null)}>
            <div style={{ background: '#fff', padding: 16, minWidth: 520, maxWidth: 960, maxHeight: '80vh', overflow: 'auto' }} onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                    <div style={{ fontWeight: 600 }}>NAP • Exchange {napModal.exchange_seq}</div>
                    <button onClick={() => setNapModal(null)}>Close</button>
                </div>
                <div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 4 }}>Extracted Data</div>
                            {Object.keys(extracted).length === 0 ? (
                                <div style={{ color: '#5F6368' }}>&lt;none&gt;</div>
                            ) : (
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {Object.entries(extracted).map(([k, v]) => (
                                        <li key={k} style={{ padding: '2px 0', display: 'flex', alignItems: 'center', gap: 6, background: expectedVar && k === expectedVar ? '#FFF3E0' : undefined }}>
                                            <strong>{k}:</strong>
                                            <span style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace' }}>{typeof v === 'string' ? v : JSON.stringify(v)}</span>
                                            {expectedVar && k === expectedVar && (<span style={{ fontSize: 11, color: '#C62828', border: '1px solid #FFB74D', padding: '0 4px', borderRadius: 8 }}>Recorded</span>)}
                                            <button className="btn-small" title="Copy" onClick={() => { try { navigator.clipboard.writeText(typeof v === 'string' ? v : JSON.stringify(v)); } catch (_) { } }} style={{ padding: '1px 6px', fontSize: 11 }}>Copy</button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 4 }}>Evaluation</div>
                            <div style={{ fontSize: 13 }}><strong>shouldAdvance:</strong> {adv === true ? 'true' : adv === false ? 'false' : '?'}</div>
                            <div style={{ fontSize: 13 }}><strong>next.action:</strong> {next.action || next.type || ''}</div>
                            {next && (next.message || next.content || next.text) && (
                                <div style={{ fontSize: 13 }}><strong>next.message:</strong> {next.message || next.content || next.text}</div>
                            )}
                            {analysis && analysis.confidence != null && (
                                <div style={{ fontSize: 13 }}><strong>confidence:</strong> {String(analysis.confidence)}</div>
                            )}
                            {analysis && analysis.relevance && (
                                <div style={{ fontSize: 13 }}><strong>relevance:</strong> {String(analysis.relevance)}</div>
                            )}
                            {analysis && analysis.conversationPattern && (
                                <div style={{ fontSize: 13 }}><strong>conversationPattern:</strong> {String(analysis.conversationPattern)}</div>
                            )}
                            {analysis && analysis.reasoning && (
                                <div style={{ fontSize: 13 }}><strong>reasoning:</strong> {String(analysis.reasoning)}</div>
                            )}
                        </div>
                    </div>
                    <div style={{ marginBottom: 8 }}>
                        <button className="btn-small" onClick={() => setNapModal(m => ({ ...m, showJson: !m.showJson }))}>{napModal.showJson ? 'Hide JSON' : 'View JSON'}</button>
                    </div>
                    {napModal.showJson && (
                        <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace', fontSize: 12, lineHeight: 1.5, background: 'var(--color-bg-base)', padding: 12, border: '1px solid #E8EAED', borderRadius: 6 }}>
                            {JSON.stringify(napModal.nap, null, 2)}
                        </pre>
                    )}
                </div>
            </div>
        </div>
    );
}
